import store from '@/store';
import {
    SET_UPLOADED_OCR,
    CHANGE_VALUE_FIELD,
    SET_DOC_NUMBER,
    SET_DOC_TYPE,
    SET_STATEMENT_ONE_DATA,
    SET_STATEMENT_TWO_DATA,
    SET_STATEMENT_THREE_DATA,
    SET_MIMETYPE_IMAGE
} from '@/lib/constants/mutations';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import { uploadRepository } from '@/forms/api/repository-factory';
import formService from '@/forms/api/services/form';
import getBase64 from '@/lib/helpers/get-base-64';
import uploadApiCall from '@/lib/helpers/upload-call-api';
import FIELD_NAMES from '@/forms/constants/field-names';
import {
    SERVICE_STATUS,
} from '@/forms/constants/services';
import getFormatedBornDate from '@/forms/helpers/get-formated-born-date';
import getFormatedExpiricyDate from '@/forms/helpers/get-formated-expiricy-date';
import getCountry from '@/forms/helpers/get-country';
import { all } from 'browser-cookies';
import getFileExt from '@/forms/helpers/get-file-extension';
import checkImageMime from '@/forms/helpers/check-image-mime';
import checkPdfMime from '@/forms/helpers/check-pdf-mime';
import sleep from '@/forms/helpers/sleep';
const parseIdData = data => ({
    [FIELD_NAMES.firstName]: data.Givename === "null" ? '' : data.Givename,
    [FIELD_NAMES.lastName]: data.Surname === "null" ? '' : data.Surname,
    [FIELD_NAMES.birthDate]: getFormatedBornDate(data.Birth),
    [FIELD_NAMES.nationality]: getCountry(data.Nationality),
    [FIELD_NAMES.gender]: data.Givename === "Sex" ? '' : data.Sex,
    [FIELD_NAMES.emiratesID]: data.PersonalNumberCheck === "null" ? '' : data.PersonalNumber + data.PersonalNumberCheck,
    [FIELD_NAMES.expiryDate]: getFormatedExpiricyDate(data.ExpirationDate),

});

const checkIdVerification = (data) => {
    if (data) {
        const parsedId = data['parsed-id'];
        if (parsedId) {
            return parsedId.Givename && parsedId.Surname;
        }
    }
    return false;
};

const commitIdInfo = (idInfo) => {
    const idData = parseIdData(idInfo);

    Object.keys(idData).forEach((key) => {
        store.commit(CHANGE_VALUE_FIELD, {
            name: key,
            newValue: idData[key],
            newValidationStates: [],
            edited: false,
        });
    });

    store.commit(SET_UPLOADED_OCR, { OCRUpdatedFields: true, idInfo });
};

const readOCRAndChangeFields = idSide => async(file, progressCallback) => {
    var isMimeTypeImage
    await checkImageMime(file, (mime) => {
        isMimeTypeImage = mime
    });
    await sleep(3000);
    if (isMimeTypeImage && (getFileExt(file.type) === 'jpg' || getFileExt(file.type) === 'jpeg' ||
            getFileExt(file.type) === 'png' || getFileExt(file.type) === 'bmp')) {
        const payload = {
            'app-num': store.state.appId,
            'id-side': idSide,
            'file-ext': getFileExt(file.type),
            image: await getBase64(file),
        };

        const response = await uploadApiCall(
            uploadRepository.identityVerification,
            payload,
            progressCallback,
        );

        const proccesedResponse = {
            file: response.file,
            name: file.name,
            size: file.size,
            serviceStatusCode: response.serviceStatusCode,
        };

        if (idSide === 'back') {
            if (checkIdVerification(response.data)) {
                const docNumber = response.data['parsed-id']['DocNumber'];
                const docType = response.data['parsed-id']['DocType'];
                store.commit(SET_DOC_NUMBER, { docNumber });
                store.commit(SET_DOC_TYPE, { docType });
                commitIdInfo(response.data['parsed-id']);

            } else {
                proccesedResponse.serviceStatusCode = 500;
                proccesedResponse.file = SERVICE_STATUS.fail;
            }
        }

        return proccesedResponse;
    }

};

export default {
    async salaryVerification(file, progressCallback) {
        if (!store.state.appId) {
            await formService.sendFormWithoutBlock();
        }

        if (!file) {
            return true;
        }
        const { values } = store.state.formData;

        const documentType = getValueByFieldName(values, FIELD_NAMES.statementType);

        if (documentType === 'Consolidated Statement') {

            store.commit(SET_STATEMENT_ONE_DATA, { statementOneData: await getBase64(file) });
        } else {
            if (!store.state.statementOneData) {

                store.commit(SET_STATEMENT_ONE_DATA, { statementOneData: await getBase64(file) });
            } else if (!store.state.statementTwoData) {

                store.commit(SET_STATEMENT_TWO_DATA, { statementTwoData: await getBase64(file) });
            } else if (!store.state.statementThreeData) {

                store.commit(SET_STATEMENT_THREE_DATA, { statementThreeData: await getBase64(file) });
            }
        }
        var isMimeTypePdf
        await checkPdfMime(file, (mime) => {
            isMimeTypePdf = mime
        });
        await sleep(3000);
        if (isMimeTypePdf && getFileExt(file.type) === 'pdf') {
            const payload = {
                'app-id': store.state.appId,
                doctype: 'Salary Certificate',
                ext: getFileExt(file.type),
                message: await getBase64(file),
            };

            const response = await uploadApiCall(
                uploadRepository.salaryVerification,
                payload,
                progressCallback,
            );

            return {
                file: response.file,
                name: file.name,
                size: file.size,
                serviceStatusCode: response.serviceStatusCode,
            };
        }

    },
    readOCRAndChangeFields(idSide) {
        return readOCRAndChangeFields(idSide);
    },

};